export default function (context) {
    context.commit('clean');
}